// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sUTqUrpJ2ETz4OOQIIn9 {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 100;
  padding: 0;
  transform: translateY(0) translateZ(0);
  transition: transform 0.5s ease;
  backface-visibility: hidden;
  pointer-events: none;
}
.sUTqUrpJ2ETz4OOQIIn9[data-hide='true'] {
  transform: translateY(100%) translateZ(0);
}
.aAkkci19E46lhJAoHfPK {
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(22px);
  -webkit-backdrop-filter: blur(22px);
  border: 1px solid #5E5E5E;
  border-radius: 18px;
  box-shadow: 0 4px 4px 0 var(--black);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 8px;
  padding: 0 24px;
  margin: 0 auto 14px;
  width: fit-content;
  max-width: 408px;
  overflow: hidden;
  pointer-events: auto;
}
.j9MbD6EO8Xy54lIhWxEF {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.75) 100%);
  height: var(--campaign-ingame-nav-backdrop-height);
  width: 100%;
  position: absolute;
  top: var(--campaign-ingame-nav-backdrop-offset);
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .aAkkci19E46lhJAoHfPK {
    padding: 0 20px;
    max-width: 300px;
    margin-bottom: 12px;
  }
}
/* Mobiles: scale the island down uniformly (icon, label, padding, gap, radius). Keep the
   --campaign-ingame-nav-* vars in campaign-variables.module.css in sync with these sizes. */
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .aAkkci19E46lhJAoHfPK {
    border-radius: 16px;
    gap: 6px;
    padding: 0 14px;
    max-width: 340px;
    margin-bottom: 12px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .aAkkci19E46lhJAoHfPK {
    border-radius: 16px;
    gap: 6px;
    padding: 0 14px;
    max-width: 340px;
    margin-bottom: 12px;
  }
}
}
}
}
@media (max-width: 374px) and (orientation: portrait) {
  .aAkkci19E46lhJAoHfPK {
    border-radius: 14px;
    gap: 4px;
    padding: 0 10px;
    margin-bottom: 10px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: landscape) {
  .aAkkci19E46lhJAoHfPK {
    border-radius: 16px;
    gap: 6px;
    padding: 0 14px;
    max-width: 340px;
    margin-bottom: 8px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: landscape) {
  .aAkkci19E46lhJAoHfPK {
    border-radius: 16px;
    gap: 6px;
    padding: 0 14px;
    max-width: 340px;
    margin-bottom: 8px;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/IngameNavigation/IngameNavigation.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sCAAsC;EACtC,+BAA+B;EAC/B,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,kFAAkF;EAClF,kDAAkD;EAClD,WAAW;EACX,kBAAkB;EAClB,+CAA+C;AACjD;AACA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;AACF;AACA;4FAC4F;AAC5F;AAAA;EACE;IACE,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;AACF;AAAA;AARA;AAAA;AAAA;AAAA;EACE;IACE,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;AACF;AAAA;AAAA;AAAA;AACA;EACE;IACE,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,mBAAmB;EACrB;AACF;AACA;AAAA;EACE;IACE,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;AACF;AAAA;AARA;AAAA;AAAA;AAAA;EACE;IACE,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;AACF;AAAA;AAAA;AAAA","sourcesContent":[".navigationContainer {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  z-index: 100;\n  padding: 0;\n  transform: translateY(0) translateZ(0);\n  transition: transform 0.5s ease;\n  backface-visibility: hidden;\n  pointer-events: none;\n}\n.navigationContainer[data-hide='true'] {\n  transform: translateY(100%) translateZ(0);\n}\n.tabsWrapper {\n  background-color: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(22px);\n  -webkit-backdrop-filter: blur(22px);\n  border: 1px solid #5E5E5E;\n  border-radius: 18px;\n  box-shadow: 0 4px 4px 0 var(--black);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  gap: 8px;\n  padding: 0 24px;\n  margin: 0 auto 14px;\n  width: fit-content;\n  max-width: 408px;\n  overflow: hidden;\n  pointer-events: auto;\n}\n.backdrop {\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.75) 100%);\n  height: var(--campaign-ingame-nav-backdrop-height);\n  width: 100%;\n  position: absolute;\n  top: var(--campaign-ingame-nav-backdrop-offset);\n}\n@media (--campaign-mobile) {\n  .tabsWrapper {\n    padding: 0 20px;\n    max-width: 300px;\n    margin-bottom: 12px;\n  }\n}\n/* Mobiles: scale the island down uniformly (icon, label, padding, gap, radius). Keep the\n   --campaign-ingame-nav-* vars in campaign-variables.module.css in sync with these sizes. */\n@media (--campaign-mobile) and (orientation: portrait) {\n  .tabsWrapper {\n    border-radius: 16px;\n    gap: 6px;\n    padding: 0 14px;\n    max-width: 340px;\n    margin-bottom: 12px;\n  }\n}\n@media (--campaign-mobile-narrow) {\n  .tabsWrapper {\n    border-radius: 14px;\n    gap: 4px;\n    padding: 0 10px;\n    margin-bottom: 10px;\n  }\n}\n@media (--campaign-mobile) and (orientation: landscape) {\n  .tabsWrapper {\n    border-radius: 16px;\n    gap: 6px;\n    padding: 0 14px;\n    max-width: 340px;\n    margin-bottom: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigationContainer": `sUTqUrpJ2ETz4OOQIIn9`,
	"tabsWrapper": `aAkkci19E46lhJAoHfPK`,
	"backdrop": `j9MbD6EO8Xy54lIhWxEF`
};
export default ___CSS_LOADER_EXPORT___;
